var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "processed-data-tree" },
    [
      !_vm.hasContent()
        ? _c(
            "div",
            [
              _c("b-card", [
                _vm._v("\n      " + _vm._s(_vm.$t("FORMS.NOTHING")) + "\n    ")
              ])
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.dataPresent
        ? _c(
            "div",
            [
              _c("b-card", { attrs: { id: "nodatadisplay" } }, [
                _vm._v("\n     No Records Found for the Current Search\n   ")
              ])
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.processedData, function(form) {
        return _c("div", [
          form
            ? _c(
                "div",
                _vm._l(form.children, function(sectionData) {
                  return _c("div", { key: sectionData.path }, [
                    sectionData && sectionData.data_type === "section"
                      ? _c(
                          "div",
                          [
                            _c(
                              "b-button",
                              {
                                directives: [
                                  {
                                    name: "b-toggle",
                                    rawName: "v-b-toggle",
                                    value: sectionData.key,
                                    expression: "sectionData.key"
                                  }
                                ],
                                attrs: { id: "mybutton" },
                                on: {
                                  click: function($event) {
                                    sectionData.show_section = !sectionData.show_section
                                  }
                                }
                              },
                              [
                                _c("span", { staticClass: "when-opened" }, [
                                  _c("i", {
                                    staticClass: "fa fa-minus-square",
                                    attrs: { "aria-hidden": "true" }
                                  })
                                ]),
                                _vm._v(" "),
                                _c("span", { staticClass: "when-closed" }, [
                                  _c("i", {
                                    staticClass: "fa fa-plus-square",
                                    attrs: { "aria-hidden": "true" }
                                  })
                                ]),
                                _vm._v(
                                  " " + _vm._s(sectionData.key) + "\n          "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-collapse",
                              {
                                staticClass: "mt-2",
                                attrs: { id: sectionData.key },
                                model: {
                                  value: sectionData.show_section,
                                  callback: function($$v) {
                                    _vm.$set(sectionData, "show_section", $$v)
                                  },
                                  expression: "sectionData.show_section"
                                }
                              },
                              [
                                _c(
                                  "b-card",
                                  _vm._l(sectionData.children, function(data) {
                                    return _c("div", { key: data.path }, [
                                      data
                                        ? _c("div", [
                                            data.children
                                              ? _c("div", [
                                                  data.data_type ===
                                                    "logical" ||
                                                  data.data_type === "npi"
                                                    ? _c(
                                                        "div",
                                                        {
                                                          attrs: {
                                                            id:
                                                              "group_" +
                                                              data.path
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "b-card",
                                                            {
                                                              attrs: {
                                                                "no-body": ""
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "text-center",
                                                                  attrs: {
                                                                    slot:
                                                                      "header"
                                                                  },
                                                                  slot: "header"
                                                                },
                                                                [
                                                                  _c(
                                                                    "strong",
                                                                    {
                                                                      on: {
                                                                        click: function(
                                                                          $event
                                                                        ) {
                                                                          _vm.inputFocused(
                                                                            data.path
                                                                          )
                                                                        }
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          _vm._f(
                                                                            "capitalize"
                                                                          )(
                                                                            data.key
                                                                          )
                                                                        )
                                                                      )
                                                                    ]
                                                                  )
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "b-popover",
                                                                {
                                                                  attrs: {
                                                                    target:
                                                                      "group_" +
                                                                      data.path,
                                                                    triggers:
                                                                      "click",
                                                                    placement:
                                                                      "top",
                                                                    boundary:
                                                                      "window"
                                                                  }
                                                                },
                                                                [
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "canvas-wrapper"
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "canvas",
                                                                        {
                                                                          attrs: {
                                                                            id:
                                                                              "canvas_" +
                                                                              data.path
                                                                          }
                                                                        }
                                                                      )
                                                                    ]
                                                                  )
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c("br"),
                                                              _vm._v(" "),
                                                              _c(
                                                                "processed-data-tree",
                                                                {
                                                                  attrs: {
                                                                    minConf:
                                                                      _vm.minConf,
                                                                    maxConf:
                                                                      _vm.maxConf,
                                                                    processedData:
                                                                      data.children,
                                                                    dataBus:
                                                                      _vm.dataBus,
                                                                    imgBase:
                                                                      _vm.imgBase,
                                                                    imgUrl:
                                                                      _vm.imgUrl,
                                                                    currentPage:
                                                                      _vm.currentPage,
                                                                    docStatus:
                                                                      _vm.docStatus
                                                                  }
                                                                }
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  data.data_type ===
                                                  "combine_data"
                                                    ? _c(
                                                        "div",
                                                        [
                                                          _c(
                                                            "processed-data-tree",
                                                            {
                                                              attrs: {
                                                                minConf:
                                                                  _vm.minConf,
                                                                maxConf:
                                                                  _vm.maxConf,
                                                                processedData: [
                                                                  data
                                                                ],
                                                                dataBus:
                                                                  _vm.dataBus,
                                                                imgBase:
                                                                  _vm.imgBase,
                                                                imgUrl:
                                                                  _vm.imgUrl,
                                                                currentPage:
                                                                  _vm.currentPage,
                                                                docStatus:
                                                                  _vm.docStatus,
                                                                dataPresent: true
                                                              }
                                                            }
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    : data.data_type ===
                                                      "single_select"
                                                      ? _c(
                                                          "div",
                                                          [
                                                            _c(
                                                              "process-single-select-data",
                                                              {
                                                                attrs: {
                                                                  content: data,
                                                                  imgBase:
                                                                    _vm.imgBase,
                                                                  imgUrl:
                                                                    _vm.imgUrl,
                                                                  currentPage:
                                                                    _vm.currentPage,
                                                                  docStatus:
                                                                    _vm.docStatus
                                                                },
                                                                on: {
                                                                  focused:
                                                                    _vm.inputFocused,
                                                                  dataUpdate:
                                                                    _vm.selectChanges
                                                                }
                                                              }
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      : data.data_type ===
                                                        "multi_select"
                                                        ? _c(
                                                            "div",
                                                            [
                                                              _c(
                                                                "process-multi-select-data",
                                                                {
                                                                  attrs: {
                                                                    content: data,
                                                                    imgBase:
                                                                      _vm.imgBase,
                                                                    imgUrl:
                                                                      _vm.imgUrl,
                                                                    currentPage:
                                                                      _vm.currentPage,
                                                                    docStatus:
                                                                      _vm.docStatus
                                                                  },
                                                                  on: {
                                                                    focused:
                                                                      _vm.inputFocused,
                                                                    dataUpdate:
                                                                      _vm.selectChanges
                                                                  }
                                                                }
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        : _vm._e(),
                                                  _vm._v(" "),
                                                  data.data_type === "name"
                                                    ? _c(
                                                        "div",
                                                        [
                                                          _c(
                                                            "processed-data-tree",
                                                            {
                                                              attrs: {
                                                                minConf:
                                                                  _vm.minConf,
                                                                maxConf:
                                                                  _vm.maxConf,
                                                                processedData: [
                                                                  data
                                                                ],
                                                                dataBus:
                                                                  _vm.dataBus,
                                                                imgBase:
                                                                  _vm.imgBase,
                                                                imgUrl:
                                                                  _vm.imgUrl,
                                                                processValueText:
                                                                  _vm.processValueText,
                                                                dataPresent:
                                                                  _vm.dataPresent,
                                                                currentPage:
                                                                  _vm.currentPage,
                                                                docStatus:
                                                                  _vm.docStatus
                                                              }
                                                            }
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    : data.data_type ===
                                                        "table_column" ||
                                                      data.data_type ===
                                                        "table_row"
                                                      ? _c("div", [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "text-center mt-3",
                                                              attrs: {
                                                                slot: "header"
                                                              },
                                                              slot: "header"
                                                            },
                                                            [
                                                              _c(
                                                                "strong",
                                                                {
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      _vm.inputFocused(
                                                                        data.path
                                                                      )
                                                                    }
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm._f(
                                                                        "capitalize"
                                                                      )(
                                                                        data.key
                                                                      )
                                                                    )
                                                                  )
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "b-button",
                                                                {
                                                                  directives: [
                                                                    {
                                                                      name:
                                                                        "b-tooltip",
                                                                      rawName:
                                                                        "v-b-tooltip.hover.right",
                                                                      modifiers: {
                                                                        hover: true,
                                                                        right: true
                                                                      }
                                                                    }
                                                                  ],
                                                                  staticClass:
                                                                    "show-table",
                                                                  attrs: {
                                                                    variant:
                                                                      "secondary",
                                                                    title: _vm.$t(
                                                                      "COMMON.SHOW_TABLE"
                                                                    )
                                                                  },
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      _vm.showTable(
                                                                        data.path
                                                                      )
                                                                    }
                                                                  }
                                                                },
                                                                [
                                                                  _c("i", {
                                                                    staticClass:
                                                                      "fa fa-table",
                                                                    attrs: {
                                                                      "aria-hidden":
                                                                        "true"
                                                                    }
                                                                  })
                                                                ]
                                                              )
                                                            ],
                                                            1
                                                          ),
                                                          _vm._v(" "),
                                                          _c("br")
                                                        ])
                                                      : _vm._e()
                                                ])
                                              : _c("div", [
                                                  data.show_field
                                                    ? _c("div", [
                                                        data.data_type ===
                                                        "signature"
                                                          ? _c(
                                                              "div",
                                                              [
                                                                _c(
                                                                  "b-form-group",
                                                                  [
                                                                    _c(
                                                                      "b-row",
                                                                      [
                                                                        _c(
                                                                          "b-col",
                                                                          {
                                                                            attrs: {
                                                                              sm:
                                                                                "8"
                                                                            }
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "div",
                                                                              [
                                                                                _c(
                                                                                  "span",
                                                                                  [
                                                                                    _vm._v(
                                                                                      _vm._s(
                                                                                        _vm._f(
                                                                                          "capitalize"
                                                                                        )(
                                                                                          data.key
                                                                                        )
                                                                                      )
                                                                                    )
                                                                                  ]
                                                                                ),
                                                                                _vm._v(
                                                                                  " "
                                                                                ),
                                                                                data.required
                                                                                  ? _c(
                                                                                      "sup",
                                                                                      {
                                                                                        staticClass:
                                                                                          "text-danger required-css"
                                                                                      },
                                                                                      [
                                                                                        _c(
                                                                                          "i",
                                                                                          {
                                                                                            staticClass:
                                                                                              "fa fa-asterisk"
                                                                                          }
                                                                                        )
                                                                                      ]
                                                                                    )
                                                                                  : _vm._e(),
                                                                                _vm._v(
                                                                                  " "
                                                                                ),
                                                                                data.status ==
                                                                                "pending"
                                                                                  ? _c(
                                                                                      "span",
                                                                                      {
                                                                                        staticClass:
                                                                                          "badge",
                                                                                        staticStyle: {
                                                                                          backgroundColor:
                                                                                            "rgb(195, 187, 187)"
                                                                                        }
                                                                                      },
                                                                                      [
                                                                                        _vm._v(
                                                                                          _vm._s(
                                                                                            _vm.$t(
                                                                                              "FORMS.PENDING"
                                                                                            )
                                                                                          )
                                                                                        )
                                                                                      ]
                                                                                    )
                                                                                  : data.status ==
                                                                                    "approved"
                                                                                    ? _c(
                                                                                        "span",
                                                                                        {
                                                                                          staticClass:
                                                                                            "badge badge-success"
                                                                                        },
                                                                                        [
                                                                                          _vm._v(
                                                                                            _vm._s(
                                                                                              _vm.$t(
                                                                                                "FORMS.APPROVED"
                                                                                              )
                                                                                            )
                                                                                          )
                                                                                        ]
                                                                                      )
                                                                                    : data.status ==
                                                                                      "rejected"
                                                                                      ? _c(
                                                                                          "span",
                                                                                          {
                                                                                            staticClass:
                                                                                              "badge badge-danger"
                                                                                          },
                                                                                          [
                                                                                            _vm._v(
                                                                                              _vm._s(
                                                                                                _vm.$t(
                                                                                                  "FORMS.REJECTED"
                                                                                                )
                                                                                              )
                                                                                            )
                                                                                          ]
                                                                                        )
                                                                                      : _vm._e(),
                                                                                _vm._v(
                                                                                  " "
                                                                                ),
                                                                                data.chunk_edited
                                                                                  ? _c(
                                                                                      "span",
                                                                                      {
                                                                                        staticClass:
                                                                                          "badge badge-edited"
                                                                                      },
                                                                                      [
                                                                                        _c(
                                                                                          "i",
                                                                                          {
                                                                                            staticClass:
                                                                                              "fa fa-check",
                                                                                            attrs: {
                                                                                              "aria-hidden":
                                                                                                "true"
                                                                                            }
                                                                                          }
                                                                                        ),
                                                                                        _vm._v(
                                                                                          " " +
                                                                                            _vm._s(
                                                                                              _vm.$t(
                                                                                                "FORMS.EDITED"
                                                                                              )
                                                                                            )
                                                                                        )
                                                                                      ]
                                                                                    )
                                                                                  : _vm._e()
                                                                              ]
                                                                            )
                                                                          ]
                                                                        ),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        _c(
                                                                          "b-col",
                                                                          {
                                                                            attrs: {
                                                                              sm:
                                                                                "4",
                                                                              align:
                                                                                "right"
                                                                            }
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "span",
                                                                              {
                                                                                directives: [
                                                                                  {
                                                                                    name:
                                                                                      "b-tooltip",
                                                                                    rawName:
                                                                                      "v-b-tooltip.hover",
                                                                                    modifiers: {
                                                                                      hover: true
                                                                                    }
                                                                                  }
                                                                                ],
                                                                                attrs: {
                                                                                  title: _vm.$t(
                                                                                    "COMMON.APPROVE"
                                                                                  )
                                                                                }
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "a",
                                                                                  {
                                                                                    staticClass:
                                                                                      "btn text-success signature-actions",
                                                                                    class: {
                                                                                      disabled:
                                                                                        data.status ===
                                                                                        "approved"
                                                                                    },
                                                                                    on: {
                                                                                      click: function(
                                                                                        $event
                                                                                      ) {
                                                                                        _vm.reviewField(
                                                                                          data,
                                                                                          "approved"
                                                                                        )
                                                                                      }
                                                                                    }
                                                                                  },
                                                                                  [
                                                                                    _c(
                                                                                      "i",
                                                                                      {
                                                                                        staticClass:
                                                                                          "icon-check"
                                                                                      }
                                                                                    )
                                                                                  ]
                                                                                )
                                                                              ]
                                                                            ),
                                                                            _vm._v(
                                                                              " "
                                                                            ),
                                                                            _c(
                                                                              "span",
                                                                              {
                                                                                directives: [
                                                                                  {
                                                                                    name:
                                                                                      "b-tooltip",
                                                                                    rawName:
                                                                                      "v-b-tooltip.hover",
                                                                                    modifiers: {
                                                                                      hover: true
                                                                                    }
                                                                                  }
                                                                                ],
                                                                                attrs: {
                                                                                  title: _vm.$t(
                                                                                    "COMMON.REJECT"
                                                                                  )
                                                                                }
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "a",
                                                                                  {
                                                                                    staticClass:
                                                                                      "btn text-danger signature-actions",
                                                                                    class: {
                                                                                      disabled:
                                                                                        data.status ===
                                                                                        "rejected"
                                                                                    },
                                                                                    on: {
                                                                                      click: function(
                                                                                        $event
                                                                                      ) {
                                                                                        _vm.reviewField(
                                                                                          data,
                                                                                          "rejected"
                                                                                        )
                                                                                      }
                                                                                    }
                                                                                  },
                                                                                  [
                                                                                    _c(
                                                                                      "i",
                                                                                      {
                                                                                        staticClass:
                                                                                          "icon-close"
                                                                                      }
                                                                                    )
                                                                                  ]
                                                                                )
                                                                              ]
                                                                            ),
                                                                            _vm._v(
                                                                              " "
                                                                            ),
                                                                            _c(
                                                                              "span",
                                                                              {
                                                                                directives: [
                                                                                  {
                                                                                    name:
                                                                                      "b-tooltip",
                                                                                    rawName:
                                                                                      "v-b-tooltip.hover",
                                                                                    modifiers: {
                                                                                      hover: true
                                                                                    }
                                                                                  }
                                                                                ],
                                                                                attrs: {
                                                                                  title: _vm.$t(
                                                                                    "COMMON.RESIZE"
                                                                                  )
                                                                                }
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "a",
                                                                                  {
                                                                                    staticClass:
                                                                                      "btn text-primary signature-actions",
                                                                                    class: {
                                                                                      disabled:
                                                                                        data.show_actions
                                                                                    },
                                                                                    on: {
                                                                                      click: function(
                                                                                        $event
                                                                                      ) {
                                                                                        _vm.enableResize(
                                                                                          data
                                                                                        )
                                                                                      }
                                                                                    }
                                                                                  },
                                                                                  [
                                                                                    _c(
                                                                                      "i",
                                                                                      {
                                                                                        staticClass:
                                                                                          "icon-crop"
                                                                                      }
                                                                                    )
                                                                                  ]
                                                                                )
                                                                              ]
                                                                            )
                                                                          ]
                                                                        )
                                                                      ],
                                                                      1
                                                                    ),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "b-row",
                                                                      [
                                                                        _c(
                                                                          "b-col",
                                                                          {
                                                                            attrs: {
                                                                              lg:
                                                                                "12"
                                                                            }
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "b-img",
                                                                              {
                                                                                attrs: {
                                                                                  fluid:
                                                                                    "",
                                                                                  alt:
                                                                                    "Signature Field",
                                                                                  src:
                                                                                    "data:image/png;base64," +
                                                                                    data.current_img_enc
                                                                                }
                                                                              }
                                                                            )
                                                                          ],
                                                                          1
                                                                        )
                                                                      ],
                                                                      1
                                                                    ),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "b-row",
                                                                      [
                                                                        _c(
                                                                          "b-col",
                                                                          {
                                                                            directives: [
                                                                              {
                                                                                name:
                                                                                  "show",
                                                                                rawName:
                                                                                  "v-show",
                                                                                value:
                                                                                  data.show_actions,
                                                                                expression:
                                                                                  "data.show_actions"
                                                                              }
                                                                            ],
                                                                            staticClass:
                                                                              "text-right",
                                                                            attrs: {
                                                                              lg:
                                                                                "12"
                                                                            }
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "a",
                                                                              {
                                                                                staticClass:
                                                                                  "btn btn-sm text-primary signature-edit",
                                                                                on: {
                                                                                  click: function(
                                                                                    $event
                                                                                  ) {
                                                                                    _vm.saveResize(
                                                                                      data
                                                                                    )
                                                                                  }
                                                                                }
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  _vm._s(
                                                                                    _vm.$t(
                                                                                      "COMMON.SAVE"
                                                                                    )
                                                                                  )
                                                                                )
                                                                              ]
                                                                            ),
                                                                            _vm._v(
                                                                              " "
                                                                            ),
                                                                            _c(
                                                                              "a",
                                                                              {
                                                                                staticClass:
                                                                                  "btn btn-sm text-secondary signature-edit",
                                                                                on: {
                                                                                  click: function(
                                                                                    $event
                                                                                  ) {
                                                                                    _vm.resetResize(
                                                                                      data
                                                                                    )
                                                                                  }
                                                                                }
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  _vm._s(
                                                                                    _vm.$t(
                                                                                      "COMMON.RESET"
                                                                                    )
                                                                                  )
                                                                                )
                                                                              ]
                                                                            )
                                                                          ]
                                                                        )
                                                                      ],
                                                                      1
                                                                    )
                                                                  ],
                                                                  1
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          : data.data_type ===
                                                            "barcode"
                                                            ? _c(
                                                                "div",
                                                                [
                                                                  _c(
                                                                    "b-form-group",
                                                                    [
                                                                      _c(
                                                                        "b-input-group",
                                                                        {
                                                                          attrs: {
                                                                            id:
                                                                              data.path
                                                                          }
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "div",
                                                                            {
                                                                              staticClass:
                                                                                "input-group-prepend",
                                                                              on: {
                                                                                click: function(
                                                                                  $event
                                                                                ) {
                                                                                  _vm.inputFocused(
                                                                                    data.path
                                                                                  )
                                                                                }
                                                                              }
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "span",
                                                                                {
                                                                                  staticClass:
                                                                                    "input-group-text"
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    _vm._s(
                                                                                      data.key
                                                                                    )
                                                                                  )
                                                                                ]
                                                                              )
                                                                            ]
                                                                          ),
                                                                          _vm._v(
                                                                            " "
                                                                          ),
                                                                          _c(
                                                                            "b-form-input",
                                                                            {
                                                                              attrs: {
                                                                                readonly:
                                                                                  "",
                                                                                type:
                                                                                  "text",
                                                                                state:
                                                                                  "true"
                                                                              },
                                                                              nativeOn: {
                                                                                focus: function(
                                                                                  $event
                                                                                ) {
                                                                                  _vm.inputFocused(
                                                                                    data.path
                                                                                  )
                                                                                }
                                                                              },
                                                                              model: {
                                                                                value:
                                                                                  data.original_value,
                                                                                callback: function(
                                                                                  $$v
                                                                                ) {
                                                                                  _vm.$set(
                                                                                    data,
                                                                                    "original_value",
                                                                                    $$v
                                                                                  )
                                                                                },
                                                                                expression:
                                                                                  "data.original_value"
                                                                              }
                                                                            }
                                                                          )
                                                                        ],
                                                                        1
                                                                      )
                                                                    ],
                                                                    1
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            : data.data_type ===
                                                              "dropdown"
                                                              ? _c(
                                                                  "div",
                                                                  [
                                                                    _c(
                                                                      "process-single-select",
                                                                      {
                                                                        attrs: {
                                                                          content: data,
                                                                          imgBase:
                                                                            _vm.imgBase,
                                                                          imgUrl:
                                                                            _vm.imgUrl
                                                                        },
                                                                        on: {
                                                                          focused:
                                                                            _vm.inputFocused,
                                                                          dataUpdate:
                                                                            _vm.selectChanges
                                                                        }
                                                                      }
                                                                    )
                                                                  ],
                                                                  1
                                                                )
                                                              : data.data_type ===
                                                                "checkbox"
                                                                ? _c(
                                                                    "div",
                                                                    [
                                                                      _c(
                                                                        "b-form-group",
                                                                        [
                                                                          _c(
                                                                            "b-form-checkbox-group",
                                                                            {
                                                                              attrs: {
                                                                                stacked:
                                                                                  "",
                                                                                id:
                                                                                  "basicCustomCheckboxes"
                                                                              }
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "div",
                                                                                {
                                                                                  staticClass:
                                                                                    "custom-control custom-checkbox",
                                                                                  staticStyle: {
                                                                                    "z-index":
                                                                                      "auto"
                                                                                  },
                                                                                  attrs: {
                                                                                    id:
                                                                                      "field_" +
                                                                                      data.path
                                                                                  },
                                                                                  on: {
                                                                                    click: function(
                                                                                      $event
                                                                                    ) {
                                                                                      _vm.inputFocused(
                                                                                        data.path
                                                                                      )
                                                                                    },
                                                                                    mouseover: function(
                                                                                      $event
                                                                                    ) {
                                                                                      _vm.inputFocused(
                                                                                        data.path
                                                                                      )
                                                                                    }
                                                                                  }
                                                                                },
                                                                                [
                                                                                  _c(
                                                                                    "input",
                                                                                    {
                                                                                      directives: [
                                                                                        {
                                                                                          name:
                                                                                            "model",
                                                                                          rawName:
                                                                                            "v-model",
                                                                                          value:
                                                                                            data.current_value,
                                                                                          expression:
                                                                                            "data.current_value"
                                                                                        }
                                                                                      ],
                                                                                      staticClass:
                                                                                        "custom-control-input",
                                                                                      attrs: {
                                                                                        type:
                                                                                          "checkbox",
                                                                                        id:
                                                                                          data.key,
                                                                                        "true-value":
                                                                                          "true",
                                                                                        "false-value":
                                                                                          "false"
                                                                                      },
                                                                                      domProps: {
                                                                                        value:
                                                                                          data.key,
                                                                                        checked: Array.isArray(
                                                                                          data.current_value
                                                                                        )
                                                                                          ? _vm._i(
                                                                                              data.current_value,
                                                                                              data.key
                                                                                            ) >
                                                                                            -1
                                                                                          : _vm._q(
                                                                                              data.current_value,
                                                                                              "true"
                                                                                            )
                                                                                      },
                                                                                      on: {
                                                                                        change: [
                                                                                          function(
                                                                                            $event
                                                                                          ) {
                                                                                            var $$a =
                                                                                                data.current_value,
                                                                                              $$el =
                                                                                                $event.target,
                                                                                              $$c = $$el.checked
                                                                                                ? "true"
                                                                                                : "false"
                                                                                            if (
                                                                                              Array.isArray(
                                                                                                $$a
                                                                                              )
                                                                                            ) {
                                                                                              var $$v =
                                                                                                  data.key,
                                                                                                $$i = _vm._i(
                                                                                                  $$a,
                                                                                                  $$v
                                                                                                )
                                                                                              if (
                                                                                                $$el.checked
                                                                                              ) {
                                                                                                $$i <
                                                                                                  0 &&
                                                                                                  (data.current_value = $$a.concat(
                                                                                                    [
                                                                                                      $$v
                                                                                                    ]
                                                                                                  ))
                                                                                              } else {
                                                                                                $$i >
                                                                                                  -1 &&
                                                                                                  (data.current_value = $$a
                                                                                                    .slice(
                                                                                                      0,
                                                                                                      $$i
                                                                                                    )
                                                                                                    .concat(
                                                                                                      $$a.slice(
                                                                                                        $$i +
                                                                                                          1
                                                                                                      )
                                                                                                    ))
                                                                                              }
                                                                                            } else {
                                                                                              _vm.$set(
                                                                                                data,
                                                                                                "current_value",
                                                                                                $$c
                                                                                              )
                                                                                            }
                                                                                          },
                                                                                          function(
                                                                                            $event
                                                                                          ) {
                                                                                            _vm.checkChanged(
                                                                                              data
                                                                                            )
                                                                                          }
                                                                                        ]
                                                                                      }
                                                                                    }
                                                                                  ),
                                                                                  _vm._v(
                                                                                    " "
                                                                                  ),
                                                                                  _c(
                                                                                    "label",
                                                                                    {
                                                                                      staticClass:
                                                                                        "custom-control-label",
                                                                                      attrs: {
                                                                                        for:
                                                                                          data.key
                                                                                      }
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        _vm._s(
                                                                                          _vm._f(
                                                                                            "capitalize"
                                                                                          )(
                                                                                            data.key
                                                                                          )
                                                                                        )
                                                                                      )
                                                                                    ]
                                                                                  ),
                                                                                  _vm._v(
                                                                                    " "
                                                                                  ),
                                                                                  data.required
                                                                                    ? _c(
                                                                                        "sup",
                                                                                        {
                                                                                          staticClass:
                                                                                            "text-danger required-css"
                                                                                        },
                                                                                        [
                                                                                          _c(
                                                                                            "i",
                                                                                            {
                                                                                              staticClass:
                                                                                                "fa fa-asterisk"
                                                                                            }
                                                                                          )
                                                                                        ]
                                                                                      )
                                                                                    : _vm._e(),
                                                                                  _vm._v(
                                                                                    " "
                                                                                  ),
                                                                                  data.edited
                                                                                    ? _c(
                                                                                        "span",
                                                                                        {
                                                                                          staticClass:
                                                                                            "badge badge-edited"
                                                                                        },
                                                                                        [
                                                                                          _c(
                                                                                            "i",
                                                                                            {
                                                                                              staticClass:
                                                                                                "fa fa-check",
                                                                                              attrs: {
                                                                                                "aria-hidden":
                                                                                                  "true"
                                                                                              }
                                                                                            }
                                                                                          ),
                                                                                          _vm._v(
                                                                                            " Edited"
                                                                                          )
                                                                                        ]
                                                                                      )
                                                                                    : _vm._e()
                                                                                ]
                                                                              ),
                                                                              _vm._v(
                                                                                " "
                                                                              ),
                                                                              data.path.split(
                                                                                "."
                                                                              )[0] ===
                                                                              _vm.currentPage.toString()
                                                                                ? _c(
                                                                                    "b-popover",
                                                                                    {
                                                                                      attrs: {
                                                                                        target:
                                                                                          "field_" +
                                                                                          data.path,
                                                                                        triggers:
                                                                                          "hover",
                                                                                        placement:
                                                                                          "top",
                                                                                        boundary:
                                                                                          "window"
                                                                                      }
                                                                                    },
                                                                                    [
                                                                                      _c(
                                                                                        "div",
                                                                                        {
                                                                                          staticClass:
                                                                                            "canvas-wrapper"
                                                                                        },
                                                                                        [
                                                                                          _c(
                                                                                            "canvas",
                                                                                            {
                                                                                              attrs: {
                                                                                                id:
                                                                                                  "canvas_" +
                                                                                                  data.path
                                                                                              }
                                                                                            }
                                                                                          )
                                                                                        ]
                                                                                      )
                                                                                    ]
                                                                                  )
                                                                                : _vm._e()
                                                                            ],
                                                                            1
                                                                          )
                                                                        ],
                                                                        1
                                                                      )
                                                                    ],
                                                                    1
                                                                  )
                                                                : _c("div", [
                                                                    data.confidence *
                                                                      100 <=
                                                                      _vm.maxConf &&
                                                                    data.confidence *
                                                                      100 >=
                                                                      _vm.minConf
                                                                      ? _c(
                                                                          "div",
                                                                          [
                                                                            _c(
                                                                              "b-form-group",
                                                                              [
                                                                                _c(
                                                                                  "label",
                                                                                  {
                                                                                    attrs: {
                                                                                      for:
                                                                                        "name"
                                                                                    }
                                                                                  },
                                                                                  [
                                                                                    _vm.groupLabel
                                                                                      ? _c(
                                                                                          "span",
                                                                                          [
                                                                                            _vm._v(
                                                                                              _vm._s(
                                                                                                _vm.groupLabel
                                                                                              )
                                                                                            )
                                                                                          ]
                                                                                        )
                                                                                      : _c(
                                                                                          "span",
                                                                                          [
                                                                                            _vm._v(
                                                                                              _vm._s(
                                                                                                _vm._f(
                                                                                                  "capitalize"
                                                                                                )(
                                                                                                  data.header
                                                                                                    ? data.header
                                                                                                    : data.key
                                                                                                )
                                                                                              )
                                                                                            )
                                                                                          ]
                                                                                        ),
                                                                                    _vm._v(
                                                                                      " "
                                                                                    ),
                                                                                    data.required
                                                                                      ? _c(
                                                                                          "sup",
                                                                                          {
                                                                                            staticClass:
                                                                                              "text-danger required-css"
                                                                                          },
                                                                                          [
                                                                                            _c(
                                                                                              "i",
                                                                                              {
                                                                                                staticClass:
                                                                                                  "fa fa-asterisk"
                                                                                              }
                                                                                            )
                                                                                          ]
                                                                                        )
                                                                                      : _vm._e(),
                                                                                    _vm._v(
                                                                                      " "
                                                                                    ),
                                                                                    data.current_value
                                                                                      ? _c(
                                                                                          "span",
                                                                                          [
                                                                                            data.date_format
                                                                                              ? _c(
                                                                                                  "span",
                                                                                                  [
                                                                                                    _c(
                                                                                                      "i",
                                                                                                      [
                                                                                                        _vm._v(
                                                                                                          "(" +
                                                                                                            _vm._s(
                                                                                                              data.date_format
                                                                                                            ) +
                                                                                                            ")"
                                                                                                        )
                                                                                                      ]
                                                                                                    )
                                                                                                  ]
                                                                                                )
                                                                                              : _vm._e(),
                                                                                            _vm._v(
                                                                                              " "
                                                                                            ),
                                                                                            data.edited &&
                                                                                            !data.is_system_generated
                                                                                              ? _c(
                                                                                                  "span",
                                                                                                  {
                                                                                                    staticClass:
                                                                                                      "badge",
                                                                                                    style: {
                                                                                                      color:
                                                                                                        "#FFFFFF",
                                                                                                      backgroundColor:
                                                                                                        "#170c9e"
                                                                                                    },
                                                                                                    attrs: {
                                                                                                      title: _vm.$t(
                                                                                                        "FORMS.CON_SCORE"
                                                                                                      )
                                                                                                    }
                                                                                                  },
                                                                                                  [
                                                                                                    _vm._v(
                                                                                                      "100"
                                                                                                    )
                                                                                                  ]
                                                                                                )
                                                                                              : _c(
                                                                                                  "span",
                                                                                                  {
                                                                                                    staticClass:
                                                                                                      "badge",
                                                                                                    style: {
                                                                                                      backgroundColor:
                                                                                                        data.color_code
                                                                                                    },
                                                                                                    attrs: {
                                                                                                      title: _vm.$t(
                                                                                                        "FORMS.CON_SCORE"
                                                                                                      )
                                                                                                    }
                                                                                                  },
                                                                                                  [
                                                                                                    _vm._v(
                                                                                                      _vm._s(
                                                                                                        Math.round(
                                                                                                          data.confidence *
                                                                                                            100
                                                                                                        )
                                                                                                      )
                                                                                                    )
                                                                                                  ]
                                                                                                ),
                                                                                            _vm._v(
                                                                                              " "
                                                                                            ),
                                                                                            data.edited &&
                                                                                            data.is_system_generated
                                                                                              ? _c(
                                                                                                  "span",
                                                                                                  {
                                                                                                    staticClass:
                                                                                                      "badge",
                                                                                                    style: {
                                                                                                      backgroundColor:
                                                                                                        data.color_code
                                                                                                    },
                                                                                                    attrs: {
                                                                                                      title: _vm.$t(
                                                                                                        "FORMS.CON_SCORE"
                                                                                                      )
                                                                                                    }
                                                                                                  }
                                                                                                )
                                                                                              : _vm._e()
                                                                                          ]
                                                                                        )
                                                                                      : _vm._e(),
                                                                                    _vm._v(
                                                                                      " "
                                                                                    ),
                                                                                    data.is_system_generated
                                                                                      ? _c(
                                                                                          "span",
                                                                                          {
                                                                                            staticClass:
                                                                                              "badge badge-edited"
                                                                                          },
                                                                                          [
                                                                                            _vm._v(
                                                                                              "System Edited "
                                                                                            ),
                                                                                            _c(
                                                                                              "i",
                                                                                              {
                                                                                                staticClass:
                                                                                                  "fa fa-exclamation",
                                                                                                attrs: {
                                                                                                  "aria-hidden":
                                                                                                    "true"
                                                                                                }
                                                                                              }
                                                                                            )
                                                                                          ]
                                                                                        )
                                                                                      : _vm._e(),
                                                                                    _vm._v(
                                                                                      " "
                                                                                    ),
                                                                                    data.edited
                                                                                      ? _c(
                                                                                          "span",
                                                                                          {
                                                                                            staticClass:
                                                                                              "badge badge-edited"
                                                                                          },
                                                                                          [
                                                                                            _c(
                                                                                              "i",
                                                                                              {
                                                                                                staticClass:
                                                                                                  "fa fa-check",
                                                                                                attrs: {
                                                                                                  "aria-hidden":
                                                                                                    "true"
                                                                                                }
                                                                                              }
                                                                                            ),
                                                                                            _vm._v(
                                                                                              " Edited"
                                                                                            )
                                                                                          ]
                                                                                        )
                                                                                      : _vm._e(),
                                                                                    _vm._v(
                                                                                      " "
                                                                                    ),
                                                                                    data.is_auto_correct &&
                                                                                    _vm.autoCorrectFlag
                                                                                      ? _c(
                                                                                          "span",
                                                                                          {
                                                                                            staticClass:
                                                                                              "badge badge-auto-corrected"
                                                                                          },
                                                                                          [
                                                                                            _c(
                                                                                              "i",
                                                                                              {
                                                                                                staticClass:
                                                                                                  "fa fa-check",
                                                                                                attrs: {
                                                                                                  "aria-hidden":
                                                                                                    "true"
                                                                                                }
                                                                                              }
                                                                                            ),
                                                                                            _vm._v(
                                                                                              " Auto-Corrected"
                                                                                            )
                                                                                          ]
                                                                                        )
                                                                                      : data.auto_correct_enable &&
                                                                                        _vm.autoCorrectFlag
                                                                                        ? _c(
                                                                                            "span",
                                                                                            {
                                                                                              staticClass:
                                                                                                "badge badge-auto_correct_enable"
                                                                                            },
                                                                                            [
                                                                                              _c(
                                                                                                "i",
                                                                                                {
                                                                                                  staticClass:
                                                                                                    "fa fa-check",
                                                                                                  attrs: {
                                                                                                    "aria-hidden":
                                                                                                      "true"
                                                                                                  }
                                                                                                }
                                                                                              ),
                                                                                              _vm._v(
                                                                                                " Auto-Correct-Enable"
                                                                                              )
                                                                                            ]
                                                                                          )
                                                                                        : _vm._e()
                                                                                  ]
                                                                                ),
                                                                                _vm._v(
                                                                                  " "
                                                                                ),
                                                                                _vm.isInsCard
                                                                                  ? _c(
                                                                                      "div",
                                                                                      {
                                                                                        attrs: {
                                                                                          id:
                                                                                            "editLabel"
                                                                                        }
                                                                                      },
                                                                                      [
                                                                                        _c(
                                                                                          "i",
                                                                                          {
                                                                                            directives: [
                                                                                              {
                                                                                                name:
                                                                                                  "b-modal",
                                                                                                rawName:
                                                                                                  "v-b-modal.changeLabel",
                                                                                                modifiers: {
                                                                                                  changeLabel: true
                                                                                                }
                                                                                              }
                                                                                            ],
                                                                                            staticClass:
                                                                                              "fa fa-pencil",
                                                                                            on: {
                                                                                              click: function(
                                                                                                $event
                                                                                              ) {
                                                                                                _vm.setLabelValue(
                                                                                                  data
                                                                                                )
                                                                                              }
                                                                                            }
                                                                                          }
                                                                                        )
                                                                                      ]
                                                                                    )
                                                                                  : _vm._e(),
                                                                                _vm._v(
                                                                                  " "
                                                                                ),
                                                                                _c(
                                                                                  "content-editable",
                                                                                  {
                                                                                    attrs: {
                                                                                      content: data,
                                                                                      imgBase:
                                                                                        _vm.imgBase,
                                                                                      imgUrl:
                                                                                        _vm.imgUrl,
                                                                                      currentPage:
                                                                                        _vm.currentPage,
                                                                                      docStatus:
                                                                                        _vm.docStatus
                                                                                    },
                                                                                    on: {
                                                                                      update:
                                                                                        _vm.inputChanged,
                                                                                      focused:
                                                                                        _vm.inputFocused
                                                                                    }
                                                                                  }
                                                                                )
                                                                              ],
                                                                              1
                                                                            )
                                                                          ],
                                                                          1
                                                                        )
                                                                      : _vm._e()
                                                                  ])
                                                      ])
                                                    : _vm._e()
                                                ])
                                          ])
                                        : _vm._e()
                                    ])
                                  })
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _c("div", [
                          sectionData
                            ? _c("div", [
                                sectionData.children
                                  ? _c("div", [
                                      sectionData.data_type === "logical" ||
                                      sectionData.data_type === "npi"
                                        ? _c(
                                            "div",
                                            {
                                              attrs: {
                                                id: "group_" + sectionData.path
                                              }
                                            },
                                            [
                                              _c(
                                                "b-card",
                                                { attrs: { "no-body": "" } },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "text-center",
                                                      attrs: { slot: "header" },
                                                      slot: "header"
                                                    },
                                                    [
                                                      _c(
                                                        "strong",
                                                        {
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              _vm.inputFocused(
                                                                sectionData.path
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm._f(
                                                                "capitalize"
                                                              )(sectionData.key)
                                                            )
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "b-popover",
                                                    {
                                                      attrs: {
                                                        target:
                                                          "group_" +
                                                          _vm.data.path,
                                                        triggers: "click",
                                                        placement: "top",
                                                        boundary: "window"
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "canvas-wrapper"
                                                        },
                                                        [
                                                          _c("canvas", {
                                                            attrs: {
                                                              id:
                                                                "canvas_" +
                                                                _vm.data.path
                                                            }
                                                          })
                                                        ]
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("br"),
                                                  _vm._v(" "),
                                                  _c("processed-data-tree", {
                                                    attrs: {
                                                      minConf: _vm.minConf,
                                                      maxConf: _vm.maxConf,
                                                      processedData:
                                                        sectionData.children,
                                                      dataBus: _vm.dataBus,
                                                      imgBase: _vm.imgBase,
                                                      imgUrl: _vm.imgUrl,
                                                      currentPage:
                                                        _vm.currentPage,
                                                      docStatus: _vm.docStatus
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      sectionData.data_type === "combine_data"
                                        ? _c(
                                            "div",
                                            [
                                              _c("processed-data-tree", {
                                                attrs: {
                                                  minConf: _vm.minConf,
                                                  maxConf: _vm.maxConf,
                                                  groupLabel: sectionData.key,
                                                  processedData: [sectionData],
                                                  dataBus: _vm.dataBus,
                                                  imgBase: _vm.imgBase,
                                                  imgUrl: _vm.imgUrl,
                                                  currentPage: _vm.currentPage,
                                                  docStatus: _vm.docStatus,
                                                  dataPresent: true
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      sectionData.data_type === "name"
                                        ? _c(
                                            "div",
                                            [
                                              _c("processed-data-tree", {
                                                attrs: {
                                                  minConf: _vm.minConf,
                                                  maxConf: _vm.maxConf,
                                                  processedData: [sectionData],
                                                  dataBus: _vm.dataBus,
                                                  imgBase: _vm.imgBase,
                                                  imgUrl: _vm.imgUrl,
                                                  processValueText:
                                                    _vm.processValueText,
                                                  dataPresent: _vm.dataPresent,
                                                  currentPage: _vm.currentPage,
                                                  docStatus: _vm.docStatus
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        : sectionData.data_type ===
                                          "single_select"
                                          ? _c(
                                              "div",
                                              [
                                                _c(
                                                  "process-single-select-data",
                                                  {
                                                    attrs: {
                                                      content: sectionData,
                                                      imgBase: _vm.imgBase,
                                                      imgUrl: _vm.imgUrl,
                                                      currentPage:
                                                        _vm.currentPage,
                                                      docStatus: _vm.docStatus
                                                    },
                                                    on: {
                                                      focused: _vm.inputFocused,
                                                      dataUpdate:
                                                        _vm.selectChanges
                                                    }
                                                  }
                                                )
                                              ],
                                              1
                                            )
                                          : sectionData.data_type ===
                                            "multi_select"
                                            ? _c(
                                                "div",
                                                [
                                                  _c(
                                                    "process-multi-select-data",
                                                    {
                                                      attrs: {
                                                        content: sectionData,
                                                        imgBase: _vm.imgBase,
                                                        imgUrl: _vm.imgUrl,
                                                        currentPage:
                                                          _vm.currentPage,
                                                        docStatus: _vm.docStatus
                                                      },
                                                      on: {
                                                        focused:
                                                          _vm.inputFocused,
                                                        dataUpdate:
                                                          _vm.selectChanges
                                                      }
                                                    }
                                                  )
                                                ],
                                                1
                                              )
                                            : sectionData.data_type ===
                                                "table_column" ||
                                              sectionData.data_type ===
                                                "table_row"
                                              ? _c("div", [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "text-center mt-3",
                                                      attrs: { slot: "header" },
                                                      slot: "header"
                                                    },
                                                    [
                                                      _c(
                                                        "strong",
                                                        {
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              _vm.inputFocused(
                                                                sectionData.path
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm._f(
                                                                "capitalize"
                                                              )(sectionData.key)
                                                            )
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "b-button",
                                                        {
                                                          directives: [
                                                            {
                                                              name: "b-tooltip",
                                                              rawName:
                                                                "v-b-tooltip.hover.right",
                                                              modifiers: {
                                                                hover: true,
                                                                right: true
                                                              }
                                                            }
                                                          ],
                                                          staticClass:
                                                            "show-table",
                                                          attrs: {
                                                            variant:
                                                              "secondary",
                                                            title: _vm.$t(
                                                              "COMMON.SHOW_TABLE"
                                                            )
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              _vm.showTable(
                                                                sectionData.path
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _c("i", {
                                                            staticClass:
                                                              "fa fa-table",
                                                            attrs: {
                                                              "aria-hidden":
                                                                "true"
                                                            }
                                                          })
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c("br")
                                                ])
                                              : _vm._e()
                                    ])
                                  : _c("div", [
                                      sectionData.show_field
                                        ? _c("div", [
                                            sectionData.data_type ===
                                            "signature"
                                              ? _c(
                                                  "div",
                                                  [
                                                    _c(
                                                      "b-form-group",
                                                      [
                                                        _c(
                                                          "b-row",
                                                          [
                                                            _c(
                                                              "b-col",
                                                              {
                                                                attrs: {
                                                                  sm: "8"
                                                                }
                                                              },
                                                              [
                                                                _c("div", [
                                                                  _c("span", [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm._f(
                                                                          "capitalize"
                                                                        )(
                                                                          sectionData.key
                                                                        )
                                                                      )
                                                                    )
                                                                  ]),
                                                                  _vm._v(" "),
                                                                  sectionData.required
                                                                    ? _c(
                                                                        "sup",
                                                                        {
                                                                          staticClass:
                                                                            "text-danger required-css"
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "i",
                                                                            {
                                                                              staticClass:
                                                                                "fa fa-asterisk"
                                                                            }
                                                                          )
                                                                        ]
                                                                      )
                                                                    : _vm._e(),
                                                                  _vm._v(" "),
                                                                  sectionData.status ==
                                                                  "pending"
                                                                    ? _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "badge",
                                                                          staticStyle: {
                                                                            backgroundColor:
                                                                              "rgb(195, 187, 187)"
                                                                          }
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              _vm.$t(
                                                                                "FORMS.PENDING"
                                                                              )
                                                                            )
                                                                          )
                                                                        ]
                                                                      )
                                                                    : sectionData.status ==
                                                                      "approved"
                                                                      ? _c(
                                                                          "span",
                                                                          {
                                                                            staticClass:
                                                                              "badge badge-success"
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                _vm.$t(
                                                                                  "FORMS.APPROVED"
                                                                                )
                                                                              )
                                                                            )
                                                                          ]
                                                                        )
                                                                      : sectionData.status ==
                                                                        "rejected"
                                                                        ? _c(
                                                                            "span",
                                                                            {
                                                                              staticClass:
                                                                                "badge badge-danger"
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                _vm._s(
                                                                                  _vm.$t(
                                                                                    "FORMS.REJECTED"
                                                                                  )
                                                                                )
                                                                              )
                                                                            ]
                                                                          )
                                                                        : _vm._e(),
                                                                  _vm._v(" "),
                                                                  sectionData.chunk_edited
                                                                    ? _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "badge badge-edited"
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "i",
                                                                            {
                                                                              staticClass:
                                                                                "fa fa-check",
                                                                              attrs: {
                                                                                "aria-hidden":
                                                                                  "true"
                                                                              }
                                                                            }
                                                                          ),
                                                                          _vm._v(
                                                                            " " +
                                                                              _vm._s(
                                                                                _vm.$t(
                                                                                  "FORMS.EDITED"
                                                                                )
                                                                              )
                                                                          )
                                                                        ]
                                                                      )
                                                                    : _vm._e()
                                                                ])
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "b-col",
                                                              {
                                                                attrs: {
                                                                  sm: "4",
                                                                  align: "right"
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    directives: [
                                                                      {
                                                                        name:
                                                                          "b-tooltip",
                                                                        rawName:
                                                                          "v-b-tooltip.hover",
                                                                        modifiers: {
                                                                          hover: true
                                                                        }
                                                                      }
                                                                    ],
                                                                    attrs: {
                                                                      title: _vm.$t(
                                                                        "COMMON.APPROVE"
                                                                      )
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "a",
                                                                      {
                                                                        staticClass:
                                                                          "btn text-success signature-actions",
                                                                        class: {
                                                                          disabled:
                                                                            sectionData.status ===
                                                                            "approved"
                                                                        },
                                                                        on: {
                                                                          click: function(
                                                                            $event
                                                                          ) {
                                                                            _vm.reviewField(
                                                                              sectionData,
                                                                              "approved"
                                                                            )
                                                                          }
                                                                        }
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "i",
                                                                          {
                                                                            staticClass:
                                                                              "icon-check"
                                                                          }
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    directives: [
                                                                      {
                                                                        name:
                                                                          "b-tooltip",
                                                                        rawName:
                                                                          "v-b-tooltip.hover",
                                                                        modifiers: {
                                                                          hover: true
                                                                        }
                                                                      }
                                                                    ],
                                                                    attrs: {
                                                                      title: _vm.$t(
                                                                        "COMMON.REJECT"
                                                                      )
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "a",
                                                                      {
                                                                        staticClass:
                                                                          "btn text-danger signature-actions",
                                                                        class: {
                                                                          disabled:
                                                                            sectionData.status ===
                                                                            "rejected"
                                                                        },
                                                                        on: {
                                                                          click: function(
                                                                            $event
                                                                          ) {
                                                                            _vm.reviewField(
                                                                              sectionData,
                                                                              "rejected"
                                                                            )
                                                                          }
                                                                        }
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "i",
                                                                          {
                                                                            staticClass:
                                                                              "icon-close"
                                                                          }
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    directives: [
                                                                      {
                                                                        name:
                                                                          "b-tooltip",
                                                                        rawName:
                                                                          "v-b-tooltip.hover",
                                                                        modifiers: {
                                                                          hover: true
                                                                        }
                                                                      }
                                                                    ],
                                                                    attrs: {
                                                                      title: _vm.$t(
                                                                        "COMMON.RESIZE"
                                                                      )
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "a",
                                                                      {
                                                                        staticClass:
                                                                          "btn text-primary signature-actions",
                                                                        class: {
                                                                          disabled:
                                                                            sectionData.show_actions
                                                                        },
                                                                        on: {
                                                                          click: function(
                                                                            $event
                                                                          ) {
                                                                            _vm.enableResize(
                                                                              sectionData
                                                                            )
                                                                          }
                                                                        }
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "i",
                                                                          {
                                                                            staticClass:
                                                                              "icon-crop"
                                                                          }
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                            )
                                                          ],
                                                          1
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "b-row",
                                                          [
                                                            _c(
                                                              "b-col",
                                                              {
                                                                attrs: {
                                                                  lg: "12"
                                                                }
                                                              },
                                                              [
                                                                _c("b-img", {
                                                                  attrs: {
                                                                    fluid: "",
                                                                    alt:
                                                                      "Signature Field",
                                                                    src:
                                                                      "data:image/png;base64," +
                                                                      sectionData.current_img_enc
                                                                  }
                                                                })
                                                              ],
                                                              1
                                                            )
                                                          ],
                                                          1
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "b-row",
                                                          [
                                                            _c(
                                                              "b-col",
                                                              {
                                                                directives: [
                                                                  {
                                                                    name:
                                                                      "show",
                                                                    rawName:
                                                                      "v-show",
                                                                    value:
                                                                      sectionData.show_actions,
                                                                    expression:
                                                                      "sectionData.show_actions"
                                                                  }
                                                                ],
                                                                staticClass:
                                                                  "text-right",
                                                                attrs: {
                                                                  lg: "12"
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "a",
                                                                  {
                                                                    staticClass:
                                                                      "btn btn-sm text-primary signature-edit",
                                                                    on: {
                                                                      click: function(
                                                                        $event
                                                                      ) {
                                                                        _vm.saveResize(
                                                                          sectionData
                                                                        )
                                                                      }
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "COMMON.SAVE"
                                                                        )
                                                                      )
                                                                    )
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "a",
                                                                  {
                                                                    staticClass:
                                                                      "btn btn-sm text-secondary signature-edit",
                                                                    on: {
                                                                      click: function(
                                                                        $event
                                                                      ) {
                                                                        _vm.resetResize(
                                                                          sectionData
                                                                        )
                                                                      }
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "COMMON.RESET"
                                                                        )
                                                                      )
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                )
                                              : sectionData.data_type ===
                                                "barcode"
                                                ? _c(
                                                    "div",
                                                    [
                                                      _c(
                                                        "b-form-group",
                                                        [
                                                          _c(
                                                            "b-input-group",
                                                            {
                                                              attrs: {
                                                                id:
                                                                  sectionData.path
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "input-group-prepend",
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      _vm.inputFocused(
                                                                        sectionData.path
                                                                      )
                                                                    }
                                                                  }
                                                                },
                                                                [
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "input-group-text"
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          sectionData.key
                                                                        )
                                                                      )
                                                                    ]
                                                                  )
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "b-form-input",
                                                                {
                                                                  attrs: {
                                                                    readonly:
                                                                      "",
                                                                    type:
                                                                      "text",
                                                                    state:
                                                                      "true"
                                                                  },
                                                                  nativeOn: {
                                                                    focus: function(
                                                                      $event
                                                                    ) {
                                                                      _vm.inputFocused(
                                                                        sectionData.path
                                                                      )
                                                                    }
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      sectionData.original_value,
                                                                    callback: function(
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        sectionData,
                                                                        "original_value",
                                                                        $$v
                                                                      )
                                                                    },
                                                                    expression:
                                                                      "sectionData.original_value"
                                                                  }
                                                                }
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                : sectionData.data_type ===
                                                  "checkbox"
                                                  ? _c(
                                                      "div",
                                                      [
                                                        _c(
                                                          "b-form-group",
                                                          [
                                                            _c(
                                                              "b-form-checkbox-group",
                                                              {
                                                                attrs: {
                                                                  stacked: "",
                                                                  id:
                                                                    "basicCustomCheckboxes"
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "custom-control custom-checkbox",
                                                                    staticStyle: {
                                                                      "z-index":
                                                                        "auto"
                                                                    },
                                                                    attrs: {
                                                                      id:
                                                                        "field_" +
                                                                        sectionData.path
                                                                    },
                                                                    on: {
                                                                      click: function(
                                                                        $event
                                                                      ) {
                                                                        _vm.inputFocused(
                                                                          sectionData.path
                                                                        )
                                                                      },
                                                                      mouseover: function(
                                                                        $event
                                                                      ) {
                                                                        _vm.inputFocused(
                                                                          sectionData.path
                                                                        )
                                                                      }
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "input",
                                                                      {
                                                                        directives: [
                                                                          {
                                                                            name:
                                                                              "model",
                                                                            rawName:
                                                                              "v-model",
                                                                            value:
                                                                              sectionData.current_value,
                                                                            expression:
                                                                              "sectionData.current_value"
                                                                          }
                                                                        ],
                                                                        staticClass:
                                                                          "custom-control-input",
                                                                        attrs: {
                                                                          type:
                                                                            "checkbox",
                                                                          id:
                                                                            sectionData.key,
                                                                          "true-value":
                                                                            "true",
                                                                          "false-value":
                                                                            "false"
                                                                        },
                                                                        domProps: {
                                                                          value:
                                                                            sectionData.key,
                                                                          checked: Array.isArray(
                                                                            sectionData.current_value
                                                                          )
                                                                            ? _vm._i(
                                                                                sectionData.current_value,
                                                                                sectionData.key
                                                                              ) >
                                                                              -1
                                                                            : _vm._q(
                                                                                sectionData.current_value,
                                                                                "true"
                                                                              )
                                                                        },
                                                                        on: {
                                                                          change: [
                                                                            function(
                                                                              $event
                                                                            ) {
                                                                              var $$a =
                                                                                  sectionData.current_value,
                                                                                $$el =
                                                                                  $event.target,
                                                                                $$c = $$el.checked
                                                                                  ? "true"
                                                                                  : "false"
                                                                              if (
                                                                                Array.isArray(
                                                                                  $$a
                                                                                )
                                                                              ) {
                                                                                var $$v =
                                                                                    sectionData.key,
                                                                                  $$i = _vm._i(
                                                                                    $$a,
                                                                                    $$v
                                                                                  )
                                                                                if (
                                                                                  $$el.checked
                                                                                ) {
                                                                                  $$i <
                                                                                    0 &&
                                                                                    (sectionData.current_value = $$a.concat(
                                                                                      [
                                                                                        $$v
                                                                                      ]
                                                                                    ))
                                                                                } else {
                                                                                  $$i >
                                                                                    -1 &&
                                                                                    (sectionData.current_value = $$a
                                                                                      .slice(
                                                                                        0,
                                                                                        $$i
                                                                                      )
                                                                                      .concat(
                                                                                        $$a.slice(
                                                                                          $$i +
                                                                                            1
                                                                                        )
                                                                                      ))
                                                                                }
                                                                              } else {
                                                                                _vm.$set(
                                                                                  sectionData,
                                                                                  "current_value",
                                                                                  $$c
                                                                                )
                                                                              }
                                                                            },
                                                                            function(
                                                                              $event
                                                                            ) {
                                                                              _vm.checkChanged(
                                                                                sectionData
                                                                              )
                                                                            }
                                                                          ]
                                                                        }
                                                                      }
                                                                    ),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "label",
                                                                      {
                                                                        staticClass:
                                                                          "custom-control-label",
                                                                        attrs: {
                                                                          for:
                                                                            sectionData.key
                                                                        }
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            _vm._f(
                                                                              "capitalize"
                                                                            )(
                                                                              sectionData.key
                                                                            )
                                                                          )
                                                                        )
                                                                      ]
                                                                    ),
                                                                    _vm._v(" "),
                                                                    sectionData.required
                                                                      ? _c(
                                                                          "sup",
                                                                          {
                                                                            staticClass:
                                                                              "text-danger required-css"
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "i",
                                                                              {
                                                                                staticClass:
                                                                                  "fa fa-asterisk"
                                                                              }
                                                                            )
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                    _vm._v(" "),
                                                                    sectionData.edited
                                                                      ? _c(
                                                                          "span",
                                                                          {
                                                                            staticClass:
                                                                              "badge badge-edited"
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "i",
                                                                              {
                                                                                staticClass:
                                                                                  "fa fa-check",
                                                                                attrs: {
                                                                                  "aria-hidden":
                                                                                    "true"
                                                                                }
                                                                              }
                                                                            ),
                                                                            _vm._v(
                                                                              " Edited"
                                                                            )
                                                                          ]
                                                                        )
                                                                      : _vm._e()
                                                                  ]
                                                                )
                                                              ]
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  : _c("div", [
                                                      sectionData.confidence *
                                                        100 <=
                                                        _vm.maxConf &&
                                                      sectionData.confidence *
                                                        100 >=
                                                        _vm.minConf
                                                        ? _c(
                                                            "div",
                                                            [
                                                              _c(
                                                                "b-form-group",
                                                                [
                                                                  _c(
                                                                    "label",
                                                                    {
                                                                      attrs: {
                                                                        for:
                                                                          "name"
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm.groupLabel
                                                                        ? _c(
                                                                            "span",
                                                                            [
                                                                              _vm._v(
                                                                                _vm._s(
                                                                                  _vm.groupLabel
                                                                                )
                                                                              )
                                                                            ]
                                                                          )
                                                                        : _c(
                                                                            "span",
                                                                            [
                                                                              _vm._v(
                                                                                _vm._s(
                                                                                  _vm._f(
                                                                                    "capitalize"
                                                                                  )(
                                                                                    sectionData.header
                                                                                      ? sectionData.header
                                                                                      : sectionData.key
                                                                                  )
                                                                                )
                                                                              )
                                                                            ]
                                                                          ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      sectionData.required
                                                                        ? _c(
                                                                            "sup",
                                                                            {
                                                                              staticClass:
                                                                                "text-danger required-css"
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "i",
                                                                                {
                                                                                  staticClass:
                                                                                    "fa fa-asterisk"
                                                                                }
                                                                              )
                                                                            ]
                                                                          )
                                                                        : _vm._e(),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      sectionData.current_value
                                                                        ? _c(
                                                                            "span",
                                                                            [
                                                                              sectionData.date_format
                                                                                ? _c(
                                                                                    "span",
                                                                                    [
                                                                                      _c(
                                                                                        "i",
                                                                                        [
                                                                                          _vm._v(
                                                                                            "(" +
                                                                                              _vm._s(
                                                                                                sectionData.date_format
                                                                                              ) +
                                                                                              ")"
                                                                                          )
                                                                                        ]
                                                                                      )
                                                                                    ]
                                                                                  )
                                                                                : _vm._e(),
                                                                              _vm._v(
                                                                                " "
                                                                              ),
                                                                              sectionData.edited &&
                                                                              !sectionData.is_system_generated
                                                                                ? _c(
                                                                                    "span",
                                                                                    {
                                                                                      staticClass:
                                                                                        "badge",
                                                                                      style: {
                                                                                        color:
                                                                                          "#FFFFFF",
                                                                                        backgroundColor:
                                                                                          "#170c9e"
                                                                                      },
                                                                                      attrs: {
                                                                                        title: _vm.$t(
                                                                                          "FORMS.CON_SCORE"
                                                                                        )
                                                                                      }
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        "100"
                                                                                      )
                                                                                    ]
                                                                                  )
                                                                                : _c(
                                                                                    "span",
                                                                                    {
                                                                                      staticClass:
                                                                                        "badge",
                                                                                      style: {
                                                                                        backgroundColor:
                                                                                          sectionData.color_code
                                                                                      },
                                                                                      attrs: {
                                                                                        title: _vm.$t(
                                                                                          "FORMS.CON_SCORE"
                                                                                        )
                                                                                      }
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        _vm._s(
                                                                                          Math.round(
                                                                                            sectionData.confidence *
                                                                                              100
                                                                                          )
                                                                                        )
                                                                                      )
                                                                                    ]
                                                                                  ),
                                                                              _vm._v(
                                                                                " "
                                                                              ),
                                                                              sectionData.edited &&
                                                                              sectionData.is_system_generated
                                                                                ? _c(
                                                                                    "span",
                                                                                    {
                                                                                      staticClass:
                                                                                        "badge",
                                                                                      style: {
                                                                                        color:
                                                                                          "#FFFFFF",
                                                                                        backgroundColor:
                                                                                          "#170c9e"
                                                                                      },
                                                                                      attrs: {
                                                                                        title: _vm.$t(
                                                                                          "FORMS.CON_SCORE"
                                                                                        )
                                                                                      }
                                                                                    }
                                                                                  )
                                                                                : _vm._e()
                                                                            ]
                                                                          )
                                                                        : _vm._e(),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      sectionData.is_system_generated
                                                                        ? _c(
                                                                            "span",
                                                                            {
                                                                              staticClass:
                                                                                "badge badge-edited"
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                "System edited "
                                                                              ),
                                                                              _c(
                                                                                "i",
                                                                                {
                                                                                  staticClass:
                                                                                    "fa fa-exclamation",
                                                                                  attrs: {
                                                                                    "aria-hidden":
                                                                                      "true"
                                                                                  }
                                                                                }
                                                                              )
                                                                            ]
                                                                          )
                                                                        : _vm._e(),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      sectionData.edited
                                                                        ? _c(
                                                                            "span",
                                                                            {
                                                                              staticClass:
                                                                                "badge badge-edited"
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "i",
                                                                                {
                                                                                  staticClass:
                                                                                    "fa fa-check",
                                                                                  attrs: {
                                                                                    "aria-hidden":
                                                                                      "true"
                                                                                  }
                                                                                }
                                                                              ),
                                                                              _vm._v(
                                                                                " Edited"
                                                                              )
                                                                            ]
                                                                          )
                                                                        : _vm._e(),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      sectionData.is_auto_correct &&
                                                                      _vm.autoCorrectFlag
                                                                        ? _c(
                                                                            "span",
                                                                            {
                                                                              staticClass:
                                                                                "badge badge-auto-corrected"
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "i",
                                                                                {
                                                                                  staticClass:
                                                                                    "fa fa-check",
                                                                                  attrs: {
                                                                                    "aria-hidden":
                                                                                      "true"
                                                                                  }
                                                                                }
                                                                              ),
                                                                              _vm._v(
                                                                                " Auto-Corrected"
                                                                              )
                                                                            ]
                                                                          )
                                                                        : sectionData.auto_correct_enable &&
                                                                          _vm.autoCorrectFlag
                                                                          ? _c(
                                                                              "span",
                                                                              {
                                                                                staticClass:
                                                                                  "badge badge-auto_correct_enable"
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "i",
                                                                                  {
                                                                                    staticClass:
                                                                                      "fa fa-check",
                                                                                    attrs: {
                                                                                      "aria-hidden":
                                                                                        "true"
                                                                                    }
                                                                                  }
                                                                                ),
                                                                                _vm._v(
                                                                                  " Auto-Correct-Enable"
                                                                                )
                                                                              ]
                                                                            )
                                                                          : _vm._e()
                                                                    ]
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _vm.isInsCard
                                                                    ? _c(
                                                                        "div",
                                                                        {
                                                                          attrs: {
                                                                            id:
                                                                              "editLabel"
                                                                          }
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "i",
                                                                            {
                                                                              directives: [
                                                                                {
                                                                                  name:
                                                                                    "b-modal",
                                                                                  rawName:
                                                                                    "v-b-modal.changeLabel",
                                                                                  modifiers: {
                                                                                    changeLabel: true
                                                                                  }
                                                                                }
                                                                              ],
                                                                              staticClass:
                                                                                "fa fa-pencil",
                                                                              on: {
                                                                                click: function(
                                                                                  $event
                                                                                ) {
                                                                                  _vm.setLabelValue(
                                                                                    sectionData
                                                                                  )
                                                                                }
                                                                              }
                                                                            }
                                                                          )
                                                                        ]
                                                                      )
                                                                    : _vm._e(),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "content-editable",
                                                                    {
                                                                      attrs: {
                                                                        content: sectionData,
                                                                        imgBase:
                                                                          _vm.imgBase,
                                                                        imgUrl:
                                                                          _vm.imgUrl,
                                                                        currentPage:
                                                                          _vm.currentPage,
                                                                        docStatus:
                                                                          _vm.docStatus
                                                                      },
                                                                      on: {
                                                                        update:
                                                                          _vm.inputChanged,
                                                                        focused:
                                                                          _vm.inputFocused
                                                                      }
                                                                    }
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        : _vm._e()
                                                    ])
                                          ])
                                        : _vm._e()
                                    ])
                              ])
                            : _vm._e()
                        ])
                  ])
                })
              )
            : _vm._e()
        ])
      }),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "changeLabelModal",
          attrs: {
            id: "changeLabel",
            title: _vm.$t("FORMS.CHANGE_LABEL"),
            "hide-header-close": "",
            centered: ""
          }
        },
        [
          _c(
            "b-card",
            { staticClass: "mb-0" },
            [
              _c(
                "b-row",
                { staticClass: "form-group" },
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: _vm.$t("FORMS.LABEL_NAME"),
                            "label-for": "labelName"
                          }
                        },
                        [
                          _c(
                            "b-form-input",
                            {
                              class: {
                                "is-invalid": _vm.$v.newLabelName.$invalid,
                                "is-valid": !_vm.$v.newLabelName.$invalid
                              },
                              attrs: {
                                id: "labelName",
                                type: "text",
                                placeholder: _vm.selectedLabel.key
                              },
                              model: {
                                value: _vm.newLabelName,
                                callback: function($$v) {
                                  _vm.newLabelName = $$v
                                },
                                expression: "newLabelName"
                              }
                            },
                            [
                              _vm._v(
                                '\n              @blur="$v.newLabelName.$touch()"\n            '
                              )
                            ]
                          ),
                          _vm._v(" "),
                          !_vm.$v.newLabelName.required
                            ? _c("b-form-invalid-feedback", [
                                _vm._v(_vm._s(_vm.$t("FORMS.REQ_LABEL")))
                              ])
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "modal-footer" }, slot: "modal-footer" },
            [
              _c(
                "b-btn",
                {
                  attrs: {
                    size: "sm",
                    variant: "secondary",
                    disabled: !_vm.$v.newLabelName.required
                  },
                  on: { click: _vm.changeName }
                },
                [_vm._v(" " + _vm._s(_vm.$t("COMMON.CHANGE")) + " ")]
              ),
              _vm._v(" "),
              _c(
                "b-btn",
                {
                  attrs: { size: "sm", variant: "light" },
                  on: { click: _vm.hideChangeModal }
                },
                [_vm._v(" " + _vm._s(_vm.$t("COMMON.CANCEL")) + " ")]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "fieldDeleteModal",
          staticClass: "modal-danger",
          attrs: {
            title: _vm.$t("COMMON.DELETE_CONFIRM"),
            "ok-title": _vm.$t("COMMON.YES"),
            "cancel-title": _vm.$t("COMMON.NO"),
            "ok-variant": "danger"
          },
          on: { ok: _vm.deleteField }
        },
        [
          _vm._v(
            "\n    " +
              _vm._s(
                _vm.$t("FORMS.DELETE_CONTENT", {
                  FIELD_NAME: _vm.selectedFieldKey
                })
              ) +
              "\n    Do you want to delete "
          ),
          _c("strong", [_vm._v(" " + _vm._s(_vm.selectedFieldKey) + " ")]),
          _vm._v(" field?\n  ")
        ]
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0a7aa556", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a7aa556","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/process/processedDataTree.vue
// module id = 1175
// module chunks = 2